export const GET_FLAGS_ACTIVITY_REQUEST = "GET_FLAGS_ACTIVITY_REQUEST";
export const GET_FLAGS_ACTIVITY_SUCCESS = "GET_FLAGS_ACTIVITY_SUCCESS";
export const GET_FLAGS_ACTIVITY_FAILURE = "GET_FLAGS_ACTIVITY_FAILURE";
